import React, { useState } from "react";
import "./AddCourtPopup.css"; // <-- we will style here
export default function AddUserPopup({ onAddUser }) {
  const [showPopup, setShowPopup] = useState(false);
  const [newUser, setNewUser] = useState({ 
    UserName: "", 
    UserMobileNo: "",
    UserEmail: "",
    UserRole: ""
});

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onAddUser(newUser); // call parent function
    setNewUser({ 
        UserName: "", 
        UserMobileNo: "",
        UserEmail: "",
        UserRole: "" 
    });
    setShowPopup(false);
  };

  return (
    <div>
      {/* Button to open popup */}
      <button onClick={() => setShowPopup(true)}>Add User</button>

      {/* Popup */}
      {showPopup && (
        <div className="popup-overlay">
            <div className="popup-container">
            <h2 className="popup-title">Add Court</h2>
            <form onSubmit={handleSubmit} className="popup-form">              
              <input
                type="text"
                placeholder="User Name"
                value={newUser.UserName}
            onChange={(e) =>
                  setNewUser({ ...newUser, UserName: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Mobile No"
                value={newUser.UserMobileNo}
                onChange={(e) =>
                  setNewUser({ ...newUser, UserMobileNo: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />              
              <input
                type="text"
                placeholder="Email"
                value={newUser.UserEmail}
                onChange={(e) =>
                  setNewUser({ ...newUser, UserEmail: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Role"
                value={newUser.UserRole}
                onChange={(e) =>
                  setNewUser({ ...newUser, UserRole: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <div className="popup-buttons">
                <button type="submit" className="btn-save">Save</button>
                <button type="button" className="btn-cancel" onClick={() => setShowPopup(false)} style={{ marginLeft: "10px" }}>Cancel</button>                
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
